type CorrectionPlacement = {
	user: { id: string };
	row: number;
	column: number;
	motivation?: string | null;
	retentionRisk?: string | null;
};

/**
 * How many people differ between a submitted review and the current grid:
 * moved, added, removed, a changed motivation, or a changed retention risk.
 * @param before placements on the submitted review
 * @param after placements on the current grid
 */
export const countCorrectionChanges = (
	before: readonly CorrectionPlacement[],
	after: readonly CorrectionPlacement[],
) => {
	const previous = new Map(before.map((item) => [item.user.id, item]));
	const next = new Map(after.map((item) => [item.user.id, item]));
	let count = 0;

	for (const [userID, item] of next) {
		const original = previous.get(userID);
		if (
			!original ||
			original.row !== item.row ||
			original.column !== item.column ||
			(original.motivation ?? '') !== (item.motivation ?? '') ||
			(original.retentionRisk ?? null) !== (item.retentionRisk ?? null)
		) {
			count += 1;
		}
	}

	for (const userID of previous.keys()) {
		if (!next.has(userID)) {
			count += 1;
		}
	}

	return count;
};
